import React, { useMemo, createContext, useContext, useEffect } from 'react';
import io from 'socket.io-client';
import customParser from 'socket.io-msgpack-parser';

import store from '../store';
import {
  addInitUnAnsweredConversation,
  addMessageUnansweredConversation
} from '../store/action/unanswered-convertations-action';
import {
  addInitAnsweredConversation,
  removeAnsweredConversation,
  addMessageAnsweredConversation,
  addAnsweredConversation
} from '../store/action/answered-conversations-action';
import {
  addMessageConversationInAttendance,
  updateStatusMessageConversationInAttendance
} from '../store/action/conversation-in-attendance-action';
import { authActiveLogout } from '../store/action/auth';
import { useChat } from './useChat';
import { getDailyClosedChat } from 'store/action/update-chat-metrics-action';
import { useSocketEvents, wrapSocketWithGlobalLoader } from './socket-utils';
import {
  useSocketConversationChatTs,
  EVENTS_EMIT
} from './useSocketConversationChatTs';

const useConversationConnectionSocketForMonitoringContext = createContext();

export function ConversationConnectionSocketForMonitoringProvider({
  children
}) {
  const { removeChatSavedById } = useChat();
  const socketConversation = useMemo(() => {
    return wrapSocketWithGlobalLoader(
      io.connect(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_CHANNEL_SOCKET_PATH,
        parser: customParser,
        transports: ['websocket'],
        upgrade: false
      })
    );
  }, []);
  const { socketChatTS } = useSocketConversationChatTs();

  useEffect(() => {
    return () => {
      socketConversation.close();
    };
  }, [socketConversation]);

  useSocketEvents(socketConversation, {
    conversas_do_atendente: async (data) => {
      await store.dispatch(
        addInitUnAnsweredConversation(data.conversasDasMinhasFilas)
      );
      await store.dispatch(addInitAnsweredConversation(data.minhasConversas));

      await store.dispatch(getDailyClosedChat(data.conversasEncerradas));
    },
    conversa_transferida_pelo_bot_para_atendente: async (data) => {
      await store.dispatch(addAnsweredConversation(data.conversa));
    },
    cliente_enviou_mensagem_portal_chat: async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };

      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      //updating list of answeredConversations in store
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );

      await store.dispatch(
        addMessageUnansweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    },
    evento_de_mensagem: async (eventMessage) => {
      await store.dispatch(
        updateStatusMessageConversationInAttendance(eventMessage)
      );
    },
    adm_enviou_sussurro: async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };
      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      //updating list of answeredConversations in store
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    },
    conversa_transferida: (data) => {
      store.dispatch(removeAnsweredConversation(data));
      //store.dispatch(removeConversationInAttendance());
    },
    conversa_encerrada: async (data) => {
      let idDaConversa = data.id;
      await store.dispatch(removeAnsweredConversation(idDaConversa));
      removeChatSavedById(idDaConversa);
      //store.dispatch(removeConversationInAttendance());
    },
    deslogar_atendente: async () => {
      await store.dispatch(authActiveLogout());
    },
    connect: () => {
      const queuesUser = JSON.parse(localStorage.getItem('queues'));
      let teamUser = [];
      if (
        localStorage.getItem('teams') !== null ||
        localStorage.getItem('teams') !== undefined
      ) {
        teamUser = JSON.parse(localStorage.getItem('teams'));
      }
      const queuesName = queuesUser.map((queue) => queue.name);
      const data = {
        login: localStorage.getItem('login'),
        name: localStorage.getItem('name'),
        socket_id: socketChatTS.id,
        nickname: localStorage.getItem('nickname'),
        queues: queuesName,
        teams: teamUser || [],
        pin_code: localStorage.getItem('pin_code')
      };
      socketChatTS.emit(EVENTS_EMIT.LOGIN_AGENT_SYSTEM, { ...data });
    }
  });

  const emitEventUpdateQueueChatCache = (newQueuesId, queueMap) => {
    const newQueues = [];
    newQueuesId.forEach((queueId) => {
      if (queueMap.has(queueId)) {
        newQueues.push(queueMap.get(queueId)?.name);
      }
    });

    socketConversation.emit('atualizar_cache_de_filas_logadas_no_chat', {
      atendente_login: localStorage.getItem('login'),
      newQueues
    });
  };
  return (
    <>
      <useConversationConnectionSocketForMonitoringContext.Provider
        value={{
          socketConversation: socketConversation,
          emitEventUpdateQueueChatCache
        }}
      >
        {children}
      </useConversationConnectionSocketForMonitoringContext.Provider>
    </>
  );
}

export function useConversationConnectionSocketForMonitoring() {
  const context = useContext(
    useConversationConnectionSocketForMonitoringContext
  );
  return context;
}
